import type { Translations } from "../types";

const hr: Translations = {
  "meta.title": "Klikovi po državama na karti",
  "meta.description":
    "Interaktivna karta svijeta: besplatni klikovi po državi te plaćena podrška putem Stripea, PayPala i Buy Me a Coffee.",

  "app.title": "Klikovi po državama na karti",

  "map.intro":
    "Klikni na državu na karti kako bi joj dao besplatan glas ili joj pošalji financijsku podršku - oboje se broji za zajedničku ljestvicu ispod. Karta odražava samo podršku unutar ove aplikacije, a ne stvarno nacionalno bogatstvo ili BDP.",
  "map.verifying": "Provjera …",
  "map.confirmNotRobot": "Prije nego što možeš dodavati besplatne klikove, brzo potvrdi da nisi robot:",
  "map.tryAgain": "Pokušaj ponovno",
  "map.registeringClick": "Registriranje klika …",
  "map.selectedCountry": "Odabrana država: {name}.",
  "map.selectFirstFeedback": "Država odabrana. Da bi dodao besplatan klik, prvo potvrdi ispod da nisi robot.",
  "map.verificationExpired": "Potvrda je istekla - ponovno potvrdi da nisi robot.",
  "map.slowDown": "Malo sporije - pričekaj trenutak prije sljedećeg klika.",
  "map.clickFailed": "Klik nije uspio biti registriran. Pokušaj ponovno.",
  "map.clickErrorGeneric": "Pogreška pri registriranju klika.",
  "map.leaderboardHeading": "Ljestvica država",
  "map.emptySelection": "Odaberi državu na karti kako bi joj dao klik ili je podržao.",
  "map.loadingData": "Učitavanje podataka …",

  "worldmap.loadError": "Kartu nije moguće učitati.",
  "worldmap.resetZoom": "Resetiraj zumiranje",
  "worldmap.resetButton": "⤾ Resetiraj",
  "worldmap.loadingMap": "Učitavanje karte …",
  "worldmap.unknownCountry": "Nepoznato",
  "worldmap.ariaClicks": "{name}: {clicks} klikova",
  "worldmap.tooltipClicks": "{clicks} klikova",

  "legend.fewer": "Manje klikova",
  "legend.more": "Više klikova",

  "list.empty": "Još nema klikova. Budi prvi!",
  "list.ariaLabel": "Ljestvica država prema klikovima",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY nije postavljen - pogledaj README za konfiguraciju.",
  "human.verificationFailedGeneric": "Provjera nije uspjela.",
  "human.networkError":
    "Provjera nije dostupna (mrežna pogreška) - provjeri VITE_SUPABASE_URL, je li verify-human objavljen te ALLOWED_ORIGIN; pogledaj README/NAVODILA.",
  "human.verificationFailedRetry": "Provjera nije uspjela, pokušaj ponovno.",

  "provider.stripe": "💳 Kartica (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Odabrana država",
  "panel.currentlyRanked": "Trenutačno na #{rank}. mjestu",
  "panel.shareCopied": "Kopirano ✓",
  "panel.shareShared": "Podijeljeno ✓",
  "panel.shareButton": "🔗 Podijeli",

  "panel.tableClicks": "Klikovi",
  "panel.tableFree": "Besplatno",
  "panel.tablePaid": "Plaćeno",
  "panel.rowAllTime": "Ukupno",
  "panel.rowThisYear": "Ove godine",
  "panel.rowThisWeek": "Ovaj tjedan",
  "panel.rowToday": "Danas",

  "panel.totalCombined": "Ukupno zbrojeno:",
  "panel.totalSupport": "Ukupna podrška:",

  "panel.paymentMethod": "Način plaćanja",
  "panel.noPaymentMethod": "Trenutačno nije dostupan nijedan način plaćanja.",
  "panel.supportAmount": "Iznos podrške (EUR)",
  "panel.amountRange": "Iznos treba biti između {min} i {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Procijenjeni plaćeni klikovi:",
  "panel.ratioInfo":
    "Omjer: {a} = {b} klikova (npr. {c} = {d} klikova). Ovo je samo procjena prije plaćanja - konačan broj klikova uvijek izračunava i potvrđuje poslužitelj na temelju stvarno potvrđenog plaćanja.",
  "panel.preparing": "Priprema …",
  "panel.continueWith": "Nastavi s {provider}",
  "panel.choosePaymentMethod": "Odaberi način plaćanja",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME nije postavljen - pogledaj README za konfiguraciju.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID nije postavljen - pogledaj README za konfiguraciju.",

  "panel.paypalAmountInfo": "Iznos: {amount} (procijenjeno {clicks} klikova). Dovrši plaćanje pomoću PayPal gumba ispod.",
  "panel.back": "← Natrag",

  "panel.bmcWarningTitle": "⚠️ Prije nego što nastaviš na BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Zalijepi kod ispod u polje za poruku/napomenu prilikom plaćanja — to je jedini način na koji ćemo znati koju državu podržavaš. Bez koda ne možemo pripisati plaćanje nijednoj državi.",
  "panel.copy": "Kopiraj",
  "panel.copied": "Kopirano ✓",
  "panel.suggestedAmount": "Predloženi iznos:",
  "panel.bmcAmountNote":
    "(procijenjeno {clicks} klikova). BuyMeCoffee nažalost ne podržava prijenos iznosa putem poveznice — unesi/odaberi ga sam na njihovoj stranici. Stvarni broj klikova uvijek se izračunava na temelju iznosa koji stvarno pošalješ na BuyMeCoffeeu, a ne prema ovoj procjeni.",
  "panel.openBmc": "Otvori BuyMeCoffee i nastavi →",
  "panel.waitingProvider": "Čekanje potvrde plaćanja od pružatelja usluge …",
  "panel.waitingConfirmation": "Čekanje potvrde plaćanja …",
  "panel.timedOut":
    "Provjera je istekla. Ako si dovršio plaćanje, karta će se ažurirati čim poslužitelj primi potvrdu - to ponekad može potrajati malo dulje.",
  "panel.checkAgain": "Provjeri ponovno",

  "panel.cancelled": "Plaćanje je otkazano ili nije uspjelo. Karta se nije promijenila.",
  "panel.tryAgain": "Pokušaj ponovno",

  "panel.confirmed": "✅ Podrška potvrđena!",
  "panel.confirmedBody": "Za {country} zabilježeno je {clicks} plaćenih klikova u iznosu od {amount}.",

  "panel.errorPreparingSupport": "Pogreška pri pripremi tvoje podrške.",
  "panel.errorPreparingPayment": "Pogreška pri pripremi plaćanja.",
  "panel.errorConfirmingPayment": "Pogreška pri potvrđivanju plaćanja.",
  "panel.errorPayingPaypal": "Pogreška pri plaćanju putem PayPala.",

  "share.unranked": "{flag}{country} treba tvoju podršku na karti svijeta!\nPomozi joj se popeti na ljestvici 👇",
  "share.rank1": "{flag}{country} trenutačno je na #1. mjestu!\nPomozi nam ostati na vrhu 👇",
  "share.rankN": "{flag}{country} trenutačno je na #{rank}. mjestu!\nPomozi nam doći do #1 👇",

  "language.switcherLabel": "Jezik",
};

export default hr;
